//Dialog.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import Cache from "Cache";
import Dialog from "components/Dialog";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Server from "components/Server";
import Snackbar from "components/Snackbar";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import Assignment from "@material-ui/icons/Assignment";
import Common from "./Common";
import Moon from "../packages/Moon";
import Chip from "@material-ui/core/Chip";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

const styles = {
	switchContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "row",
		flexWrap: "nowrap",
		width: "100%",
		height: "40px",
		boxSizing: "border-box"
	},
	tokenGridContainer: {
		position: "relative"
	},
	visibilityIcon: {
		position: "absolute",
		top: "calc(50% - 40px)",
		right: "5px"
	},
	copyToClipboartdIcon: {
		position: "absolute",
		top: "calc(50% - 40px)",
		right: "45px"
	}
};

const classes = StyleSheet.create({
	switch: { color: "#555" },
	inputLabel: { fontSize: "0.8rem" }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

class Settings extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
            apiHostInput: "",
            shopifyShopInput: "",
            apiHostInputError: false,
            shopifyShopInputError: false,
			additionalAttributesInput: [],
			additionalAttributes: [],
			dialog: false,
			canClose: true,
			rtlGrid: Moon.use(false),
			reversePositionsOnSave: Moon.use(false),
			tokenApiInput: "0123456789",
			userApiInput: "0123456789",
			showUserApi: false,
			showTokenApi: false
        };
        this.platform = null;
		this.tokenApiRef = React.createRef();
		this.userApiRef = React.createRef();
		this.handleOnClick = this.handleOnClick.bind(this);
		this.toggleVisibility = this.toggleVisibility.bind(this);
		this.getTokenDone = this.getTokenDone.bind(this);
		this.doToggleVisibility = this.doToggleVisibility.bind(this);
	}

	componentWillMount() {
		Moon.addStar(this);
		this.getSettings();
	}

	componentWillReceiveProps = nextProps => {
		if (nextProps.open === this.props.open) return;
		if (nextProps.open === true && Cache.settings != null) {
			this.initSettings(Cache.settings, Cache.additionalAttributes);
			this.setState({
				dialog: true,
				canClose: true
			});
		}
	};

	initSettings(settings, additionalAttributes) {
        this.platform = settings.platform;
		this.setState({
            apiHostInput: settings.hostname != null ? settings.hostname : "",
            shopifyShopInput: settings.shopify_shop,
			additionalAttributesInput: settings.additional_attributes
				? JSON.parse(settings.additional_attributes)
				: [],
			additionalAttributes: additionalAttributes,
			rtlGrid: settings.RTL != null ? JSON.parse(settings.RTL) : false,
			reversePositionsOnSave:
				settings.reverse_positions_on_save != null
					? JSON.parse(settings.reverse_positions_on_save)
					: false,
			tokenApiInput: "0123456789",
			userApiInput: "0123456789",
			showTokenApi: false,
			showUserApi: false
		});
	}

	getSettings() {
		Server.post("/settings/get", null, this.getSettingsDone.bind(this));
	}

	getSettingsDone(res) {
		console.log(res);
		let settings = res.data.settings;
		let additionalAttributes = res.data.additional_attributes;
		Cache.settings = settings;
		Cache.additionalAttributes = additionalAttributes;
		if (settings == null || settings.hostname == null)
			this.forceOpenSettings();
		else this.initSettings(settings, additionalAttributes);
	}

	forceOpenSettings() {
		this.props.onOpen();
		this.setState({ dialog: true, canClose: false });
	}

	dialogState(enabled, canClose) {
		this.setState({ dialog: enabled, canClose: canClose });
	}

	handleOnClick() {
		if (this.validateInputs() == false) return;
		this.saveSettings();
	}

	validateInputs() {
		let validate = true;
		if (this.state.apiHostInput.length < 1) {
			validate = false;
		}
		this.setState({ apiHostInputError: !validate });
		return validate;
	}

	saveSettings() {
		let data = {};
        data.hostname = this.state.apiHostInput;
        if (this.platform == "shopify")
            data.shopify_shop = this.state.shopifyShopInput;
		data.additional_attributes = JSON.stringify(
			this.state.additionalAttributesInput
		);
		data.RTL = this.state.rtlGrid;
		data.reverse_positions_on_save = this.state.reversePositionsOnSave;
		let demo = Common.isDemo();
		if (demo) {
			Snackbar.info("Demo user - settings was not saved!");
			this.setState({ dialog: false });
			return;
		}
		Server.post("/settings/save", data, res => {
			this.saveSettingsDone(res, data);
		});
	}

	login(res) {
		console.log(res);
	}

	saveSettingsDone(res, savedData) {
		Cache.settings = savedData;
		Snackbar.info("Settings was saved!");
		this.setState({ dialog: false });
	}

	closeDialog() {
		this.initSettings(Cache.settings, Cache.additionalAttributes);
		this.setState({ dialog: false }, () => {
			this.props.onClose();
		});
	}

	handleSwitchOnChange = name => event => {
		this.setState({
			[name]: event.target.checked
		});
	};
	handleInputOnChange = name => event => {
		this.setState({
			[name]: event.target.value
		});
	};

	handleChange = prop => event => {
		this.setState({ [prop]: event.target.value });
	};

	toggleVisibility(toggleName) {
		if (Cache.settings.user_api) this.doToggleVisibility(toggleName);
		else
			Server.post("/settings/get_token", {}, res =>
				this.getTokenDone(res, toggleName)
			);
	}

	getTokenDone(res, toggleName) {
		let settings = res.data.settings;
		Cache.settings.user_api = settings.user_api;
		Cache.settings.token_api = settings.token_api;
		this.doToggleVisibility(toggleName);
	}

	doToggleVisibility(toggleName) {
		if (toggleName == "userApi") {
			this.setState({
				showUserApi: !this.state.showUserApi,
				userApiInput: !this.state.showUserApi
					? Cache.settings.user_api
					: "0123456789"
			});
		} else if (toggleName == "tokenApi") {
			this.setState({
				showTokenApi: !this.state.showTokenApi,
				tokenApiInput: !this.state.showTokenApi
					? Cache.settings.token_api
					: "0123456789"
			});
		}
	}

	renderSettingsBase() {
		return (
			<div>
				<Grid container spacing={2} justify={"center"}>
                <Grid item xs={10}>
						<TextField
							required
							type={"text"}
							label={"API host url"}
							defaultValue={this.state.apiHostInput}
							margin="normal"
							fullWidth
							error={this.state.apiHostInputError}
							helperText={
								this.state.apiHostInputError
									? "Required field can't be empty!"
									: null
							}
							onChange={this.handleInputOnChange("apiHostInput")}
						/>
					</Grid>
                    {/* {this.platform == "shopify" && 
                    <Grid item xs={10}>
						<TextField
							required
							type={"text"}
							label={"Shopify Shop"}
							defaultValue={this.state.shopifyShopInput}
							margin="normal"
							fullWidth
							error={this.state.shopifyShopInputError}
							helperText={
								this.state.shopifyShopInputError
									? "Required field can't be empty!"
									: null
							}
							onChange={this.handleInputOnChange("shopifyShopInput")}
						/>
					</Grid>
                    } */}
					<Grid item xs={10}>
						<InputLabel
							classes={{ root: css(classes.inputLabel) }}
							htmlFor="select-multiple-chip"
						>
							On Screen additional attribute
							<b>
								{this.state.additionalAttributes.length === 0 &&
									" (Update editea plugin to enable)"}
							</b>
						</InputLabel>
						<br />
						<Select
							multiple
							disabled={
								this.state.additionalAttributes.length === 0
							}
							value={this.state.additionalAttributesInput}
							onChange={this.handleInputOnChange(
								"additionalAttributesInput"
							)}
							input={<Input id="select-multiple-chip" />}
							fullWidth
							renderValue={selected => (
								<div>
									{selected.map(value => (
										<Chip key={value} label={value} />
									))}
								</div>
							)}
							MenuProps={MenuProps}
						>
							{this.state.additionalAttributes.length > 0 && this.state.additionalAttributes.map(name => (
								<MenuItem key={name} vlaue={name}>
									{name}
								</MenuItem>
							))}
						</Select>
					</Grid>
					<Grid
						key={"Grid_User_Api"}
						style={styles.tokenGridContainer}
						item
						xs={10}
					>
						<TextField
							inputRef={ref => (this.userApiRef = ref)}
							id="user_api"
							type={this.state.showUserApi ? "text" : "password"}
							label={"User API"}
							value={this.state.userApiInput}
							margin="normal"
							fullWidth
							error={false}
						/>
						<div style={styles.visibilityIcon}>
							<Button
								aria-label="Toggle user api visibility"
								onClick={() => this.toggleVisibility("userApi")}
							>
								{this.state.showUserApi ? (
									<VisibilityOff />
								) : (
									<Visibility />
								)}
							</Button>
						</div>
						{this.state.showUserApi && (
							<div style={styles.copyToClipboartdIcon}>
								<Button
									aria-label="Copy to clipboard"
									onClick={() =>
										Common.copyToClipboartd(
											this.userApiRef,
											"User API"
										)
									}
								>
									<Assignment />
								</Button>
							</div>
						)}
					</Grid>
					<Grid
						key={"Grid_Token"}
						style={styles.tokenGridContainer}
						item
						xs={10}
					>
						<TextField
							inputRef={ref => (this.tokenApiRef = ref)}
							id="token"
							type={this.state.showTokenApi ? "text" : "password"}
							label={"Token API"}
							value={this.state.tokenApiInput}
							margin="normal"
							fullWidth
							error={false}
						/>
						<div style={styles.visibilityIcon}>
							<Button
								aria-label="Toggle token visibility"
								onClick={() =>
									this.toggleVisibility("tokenApi")
								}
							>
								{this.state.showTokenApi ? (
									<VisibilityOff />
								) : (
									<Visibility />
								)}
							</Button>
						</div>
						{this.state.showTokenApi && (
							<div style={styles.copyToClipboartdIcon}>
								<Button
									aria-label="Copy to clipboard"
									onClick={() =>
										Common.copyToClipboartd(
											this.tokenApiRef,
											"Token API"
										)
									}
								>
									<Assignment />
								</Button>
							</div>
						)}
					</Grid>
					<Grid item xs={10}>
						<div style={styles.switchContainer}>
							<Typography
								classes={{ root: css(classes.switch) }}
								variant="subtitle1"
							>
								Grid Right-To-Left (RTL)
							</Typography>
							<Switch
								color="primary"
								checked={this.state.rtlGrid}
								onChange={this.handleSwitchOnChange("rtlGrid")}
								value={this.state.rtlGrid}
							/>
						</div>
					</Grid>
					<Grid item xs={10}>
						<div style={styles.switchContainer}>
							<Typography
								classes={{ root: css(classes.switch) }}
								variant="subtitle1"
							>
								Reverse positions (Save {"&"} Publish)
							</Typography>
							<Switch
								color="primary"
								checked={this.state.reversePositionsOnSave}
								onChange={this.handleSwitchOnChange(
									"reversePositionsOnSave"
								)}
								value={this.state.reversePositionsOnSave}
							/>
						</div>
					</Grid>
					<Grid item xs={10}>
						<div style={styles.switchContainer}>
							<Typography
								classes={{ root: css(classes.rtl) }}
								variant="subtitle1"
							>
								Tour
							</Typography>
							<Button
								variant="outlined"
								color="primary"
								onClick={() => window.App.reopenTour()}
							>
								Enable Tour
							</Button>
						</div>
					</Grid>
				</Grid>
			</div>
		);
	}

	render() {
		if (this.props.enabled == false) return null;
		return (
			<Dialog
				open={this.state.dialog}
				onClose={this.closeDialog.bind(this)}
				canClose={this.state.canClose}
				buttons={[
					{ label: "save & close", onClick: this.handleOnClick }
				]}
				title="settings"
			>
				{this.renderSettingsBase()}
			</Dialog>
		);
	}
}

export default Settings;
